import { useEffect } from "react";

const injected = new Set();

export function loadGtm(containerId, options = {}) {
  if (!containerId || typeof window === "undefined") return false;
  if (injected.has(containerId)) return false;

  const domId = "gtm-" + containerId;
  if (document.getElementById(domId)) {
    injected.add(containerId);
    return false;
  }
  injected.add(containerId);

  const layer = options.dataLayerName || "dataLayer";

  window[layer] = window[layer] || [];
  window[layer].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

  let src =
    "https://www.googletagmanager.com/gtm.js?id=" + encodeURIComponent(containerId);
  if (layer !== "dataLayer") src += "&l=" + encodeURIComponent(layer);
  /* Only needed if you use GTM environments */
  if (options.auth) src += "&gtm_auth=" + encodeURIComponent(options.auth);
  if (options.preview) {
    src += "&gtm_preview=" + encodeURIComponent(options.preview) + "&gtm_cookies_win=x";
  }

  const s = document.createElement("script");
  s.id = domId;
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
  return true;
}

/**
 * Push an event to the container this LP loaded.
 * No-op when GTM was never loaded, so shared components stay safe.
 */
export function gtmEvent(event, params = {}, dataLayerName = "dataLayer") {
  if (typeof window === "undefined") return;
  window[dataLayerName] = window[dataLayerName] || [];
  window[dataLayerName].push({ event, ...params });
}

export default function GtmLoader({ containerId, dataLayerName, auth, preview }) {
  useEffect(() => {
    loadGtm(containerId, { dataLayerName, auth, preview });
  }, [containerId, dataLayerName, auth, preview]);

  return null;
}
